var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{attrs:{"rounded":"lg","min-height":"268"}},[_c('v-container',[_c('h3',{staticClass:"font-weight-medium"},[_vm._v("Your Feed")]),_c('div',_vm._l((5),function(item){return _c('Feed',{key:item})}),1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }